import { render, staticRenderFns } from "./ActDate.vue?vue&type=template&id=868fcd54"
import script from "./ActDate.vue?vue&type=script&lang=js"
export * from "./ActDate.vue?vue&type=script&lang=js"
import style0 from "./ActDate.vue?vue&type=style&index=0&id=868fcd54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports